export default "__VITE_ASSET__CiV$3GdZ__"